export const REDUCER_NAME = 'LoanDetailsNotes'

export const actions = {
  INITIALIZE: 'LoanDetailsNotes/INITIALIZE',
  CHANGE_FILTER: 'LoanDetailsNotes/CHANGE_FILTER',
}

export const initialState = {
  filter: undefined,
}
